<script>
export default {
  name: 'Accordion',
  props: {
    title: String,
    isOverflow: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    isSelected: Function
  }
}
</script>

<template>
  <span class="accordion"
           :class="{'accordion-isActive' : isOpen}">
    <div class="accordion-header"
         @click.prevent="isSelected">
      <span class="accordion-header-title">
        {{title}}
        <slot name="title" />
      </span>
      <span>
        <i class="fa-sharp fa-regular"
           :class="{'fa-chevron-up': isOpen, 'fa-chevron-down' : !isOpen}" />
      </span>
    </div>
    <div :class="{
            'accordion-content' : isOpen,
            'accordion-content-isOverflow' : isOverflow
          }">
      <slot v-if="isOpen"
            name="content" />
    </div>
  </span>
</template>

<style lang="scss" scoped>
.accordion {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 1rem;
  &-isActive {
    max-height: 200px;
    overflow: hidden;
  }
  &-header {
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    padding-top: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    width: 100%;
    color: white;
    cursor: pointer;
    &-title {
      font-family: 'Helvetica Neue';
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      color: white;
    }
  }
  &-content {
    overflow: auto;
    @media only screen and (max-width: 550px) {
      width: 100%;
      padding-left: -1rem;
    }
    &-isOverflow {
      overflow: hidden !important;
    }
  }
}
.filter-modal .accordion-header-title {
  display: block;
  width: 100%;
  position: relative;
}
</style>
